<template>
    <span>
        {{ Translations.sections.dayTemplates.sectionTitle }}
    </span>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Bootstrap from 'bootstrap-vue'
    import Translations from '@/store/translations';

    Vue.use(Bootstrap);

    export default {
        name: "DaytemplateSectionHeader",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
</style>